<template>
    <div>
        <trophy-challenge-registration-success v-if="null !== registration"/>
        <form v-on:submit.prevent="onSubmit" v-if="null === registration" class="trophy-challenge-form">
            <trophy-challenge-registration-form/>
            <input type="submit" class="button view-hero-red  view-show-arrow-white" :disabled="processing" :value="processing ? 'Odesílám...' : 'Odeslat do soutěže'"/>
            <div v-for="error in errors.filter(e => e.index === -1)">
                <div class="error-message">
                    <p>{{error.msg}}</p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import TrophyChallengeRegistrationForm from './Form';
    import {isPhone, isEmail} from '../../helpers/validation';
    import TrophyChallengeRegistrationSuccess from "./RegistrationSuccess";

    export default {
        name:       'TrophyChallengeRegistration',
        components: {
            TrophyChallengeRegistrationSuccess,
            TrophyChallengeRegistrationForm
        },
        computed:   {
            ...mapGetters('trophyChallenge', ['form', 'registration', 'processing', 'errors'])
        },
        methods:    {
            ...mapActions('trophyChallenge', ['createRegistration', 'setErrors']),
            onSubmit() {
              console.log("form valid",this.isValid())
                if (this.isValid()) {
                    this.createRegistration(this.form);
                }
            },
            isValid() {
                let errors = [];
                const { executionCompany, designer, architect, generalContractor, city, rules, notOwner, ownerInfo, files } = this.form;

                if (!executionCompany || executionCompany.length === 0) {
                    errors.push({ msg: 'Zadejte jméno realizční firmy', index: 1, field: 'executionCompany' });
                }
                if (!designer || designer.length === 0) {
                    errors.push({ msg: 'Zadejte jméno projektanta', index: 1, field: 'designer' });
                }
                if (!architect || architect.length === 0) {
                    errors.push({ msg: 'Zadejte jméno architekta', index: 1, field: 'architect' });
                }
                if (!generalContractor || generalContractor.length === 0) {
                    errors.push({ msg: 'Zadejte jméno generálního dodavatele', index: 1, field: 'generalContractor' });
                }
                if (!city || city.length === 0) {
                    errors.push({ msg: 'Zadejte město realizace', index: 1, field: 'city' });
                }
                if (false === rules) {
                    errors.push({ msg: 'Musíte souhlasit s podmínkami soutěže', index: 1, field: 'rules' });
                }
                if (files.length !== 2) {
                    errors.push({ msg: 'Nahrajte všechny požadované fotografie', index: 1, field: 'files' });
                }
console.log("err", errors)
                this.setErrors(errors);
                return errors.length ? false : true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/trophy-challenge/RegistrationContainer.vue